import {
  CountryData,
  countryDataByCode,
  SupportedCountryCodes,
  UnsupportedCountries,
} from '@Common/countries/country_data';
import { CountryCode } from '@Common/types/countries';

export const countryMap: Record<
  // oxlint-disable-next-line ban-types -- allow {} here to enable autocomplete
  keyof typeof countryDataByCode | (string & {}),
  CountryData
> = countryDataByCode;

export const allCountryCodes = Object.keys(countryDataByCode) as SupportedCountryCodes[];

export const eeaCountryCodes = allCountryCodes.filter((code) => countryDataByCode[code].isEEA);

export const skipOnboardingTaxNumberRequiredCountryCodes: SupportedCountryCodes[] = [
  'FR',
  'NL',
  'DE',
  'LU',
];

// In prod we only allow these to protect
export const b2cProdLaunchedCountryCodes: SupportedCountryCodes[] = [
  'BE',
  'PT',
  'DK',
  'LT',
  'LV',
  'SE',
  'SI',
  'IE',
  'PL',
  'FR',
  'NL',
  'DE',
  'IT',
  'LU',
];

export const unsupportedCountryCodes: UnsupportedCountries[] = [
  'AC',
  'AI',
  'AS',
  'AW',
  'BQ',
  'CW',
  'EH',
  'IO',
  'PM',
  'SX',
  'TA',
];

export const b2cNonProdLaunchedCountryCodes = allCountryCodes.filter(
  (code) => code === 'GB' || countryDataByCode[code].showInEuOnboarding,
);

export const currencies = Object.values(countryDataByCode).map((val) => val.currency);

export const mapOverseasToCountryCode = (country: CountryCode): CountryCode => {
  const overseas = {
    FR: ['GF', 'GP', 'MQ', 'RE', 'YT'],
  };

  return Object.entries(overseas).reduce((originalCountry: CountryCode, [key, values]) => {
    if (values.includes(country)) {
      return key;
    }
    return originalCountry;
  }, country);
};
